import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/charts/stacking/stacking.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
